import React, { useEffect, useRef } from 'react'
import History from './History'
import Footer from 'components/Footer';

function About() {
  const refs = useRef([]);
  useEffect(() => {
    window.scrollTo(0, 0);

    // Intersection Observer 콜백 함수
    const observerCallback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 요소가 뷰포트에 들어오면 'visible' 클래스 추가
          entry.target.classList.add('visible');
          observer.unobserve(entry.target); // 관찰 중단
        }
      });
    };

    // Intersection Observer 설정
    const observerOptions = {
      root: null, // 뷰포트를 기준으로
      rootMargin: '0px',
      threshold: 0.2 // 10% 이상이 보일 때 콜백 실행
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // 모든 대상 요소에 대해 관찰 시작
    refs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      // 컴포넌트 언마운트 시 관찰 중단
      refs.current.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, []);
  return (
    <>
      <div className='about_first'>
        ABOUT US
        <span className='sub_span about'>
          <br />
          모든 임직원의 창조적 열정을 응원하고<br />
          다양한 배움의 기회를 제공하는 신뢰 받는 기업
        </span>
      </div>

      <div className='front_wrap about' ref={(el) => (refs.current[0] = el)}>

        <img src='images/com_introduce.png' className='front_main_img' alt='이케이시스 메인 이미지' />
        <div className='about_intro'>
          <span className='about_span'>
            {/* 최적의 솔루션을 제공하는 <span className='strong_sub'>GIS</span> 컨설팅 */}
            이케이시스는 기업의 다양한 업무환경에 적합한 소프트웨어 맞춤 컨설팅을 통해서 고객사의 업무 효율성을 높이고 더 나은 업무환경 구축을 위한 최적의 솔루션을 제공합니다.빠르게 변화하는 IT아웃소싱 환경에 클라이언트, 파트너스 모두가 안전하게 프로젝트를 진행할 수 있도록 시스템을 개발하고 문제점을 개선하기 위해 노력하고 있습니다.
          </span>
          <div className='sign'>
            이케이시스 대표 <img src='images/com_signature.png' />
          </div>
        </div>
      </div>
      <div className='line_con'>
        <span className='main_line'></span>
      </div>
      <div className='about_div' ref={(el) => (refs.current[1] = el)}>
      <div className='about_head_intro' ref={(el) => (refs.current[2] = el)}>
      탁월한 IT 기술 인력과 축적된 기술력을 바탕으로<br/>
      고객에게 최고의 서비스를 제공합니다
      </div>
      <div className='about_head' ref={(el) => (refs.current[3] = el)}>
        <div className='vison_con'>
          <img src='images/about_vision.png' alt='vision' />
          <h2><span className='icon1'>V</span>ision</h2>
          <span>각 사업분야에서 핵심요소로 적용되어 고객에게 최고의 가치를 제공</span>
        </div>
        <div className='vison_con'>
          <img src='images/about_passion.png' alt='passion' />
          <h2><span className='icon2'>P</span>assion</h2>
          <span>차별화 된 IT Consulting을 제공 다양한 Business Application 전달</span>
        </div>
        <div className='vison_con'>
          <img src='images/about_role.png' alt='role' />
          <h2><span className='icon3'>R</span>ole</h2>
          <span>끊임없는 기술개발과 창조적인 사고, 시장을 주도하는 역할을 수행</span>
        </div>
        <div className='vison_con'>
          <img src='images/about_technique.png' alt='technique'/>
          <h2><span className='icon4'>T</span>echnique</h2>
          <span>국내 최고의 솔루션과 서비스를 위해 신기술 개발 및 탄탄한 기술력 유지</span>
        </div>
      </div>
      </div>
      <div className='padding_div' />

    <History ref={(el) => (refs.current[4] = el)}/>
      
      <div className='padding_div' />
      <Footer/>
    </>
  )
}

export default About
